"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var regex = /^(?!BG|GB|NK|KN|TN|NT|ZZ)((?![DFIQUV])([A-Z])(?![DFIQUVO])([A-Z]))[0-9]{6}[A-D ]$/;
exports.default = function (value) {
    return regex.test(value);
};
